import HomeStudioMedicoList from "./components/HomeStudioMedicoList.vue";

export default {
    HomeStudioMedicoList,
};
